import { useCallback, useEffect, useState } from 'react';
import { GetAppointmentHistoryAPI, GetPatientHistoryAPI } from '../../api/API';

const LOADERS = {
  patient: GetPatientHistoryAPI,
  appointment: GetAppointmentHistoryAPI,
};

/**
 * useActivityHistory
 *
 * Carrega o histórico (quem cadastrou/alterou e quando) de um paciente ou de
 * um agendamento. Recarrega quando o id ou o refreshKey mudam.
 *
 * @param {'patient'|'appointment'} kind
 * @param {number|string|null} id
 * @param {string} [refreshKey] - muda quando o registro foi alterado na tela
 */
function useActivityHistory(kind, id, refreshKey = '') {
  const [entries, setEntries] = useState([]);
  const [labels, setLabels] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    if (id === null || id === undefined || id === '') return undefined;
    let active = true;
    setIsLoading(true);
    setError(null);
    LOADERS[kind](id, (response) => {
      if (!active) return;
      if (!response || response.status !== 'SUCCESS') {
        setError(response?.message || 'Não foi possível carregar o histórico.');
        setIsLoading(false);
        return;
      }
      setEntries(response.data?.entries || []);
      setLabels(response.data?.labels || {});
      setIsLoading(false);
    });
    return () => { active = false; };
  }, [kind, id]);

  useEffect(() => load(), [load, refreshKey]);

  return { entries, labels, isLoading, error, reload: load };
}

export default useActivityHistory;
